var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfinity = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 20,
    viewBox: "0 0 24 24",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    fill: "#fff",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.954 5.954c-2.693 0-4.726 1.838-5.954 3.364-1.228-1.526-3.261-3.364-5.954-3.364a6.046 6.046 0 0 0 0 12.092c2.693 0 4.726-1.838 5.954-3.364 1.228 1.526 3.261 3.364 5.954 3.364a6.046 6.046 0 0 0 0-12.092zm-11.908 9.092a3.046 3.046 0 0 1 0-6.092c1.816 0 3.407 1.821 4.213 3.046-.806 1.225-2.397 3.046-4.213 3.046zm11.908 0c-1.816 0-3.407-1.821-4.213-3.046.806-1.225 2.4-3.046 4.213-3.046a3.046 3.046 0 0 1 0 6.092z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfinity);
export default ForwardRef;